/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { GridColumnOptionsSectionBase } from "./GridColumnOptionsSectionBase";
import { StringComparer } from "igniteui-react-core";
import { markType } from "igniteui-react-core";
/**
 * @hidden
 */
var GridColumnOptionsSimpleSectionBase = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(GridColumnOptionsSimpleSectionBase, _super);
    function GridColumnOptionsSimpleSectionBase() {
        var _this = _super.call(this) || this;
        _this.br = null;
        _this.bp = true;
        return _this;
    }
    Object.defineProperty(GridColumnOptionsSimpleSectionBase.prototype, "bs", {
        get: function () {
            if (null == this.br) {
                return this.bu;
            }
            return this.br;
        },
        set: function (a) {
            var b = this.bs;
            if (0 == StringComparer.b.compare(a, b)) {
                return;
            }
            this.br = a;
            this.a8("Caption", b, this.br);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridColumnOptionsSimpleSectionBase.prototype, "bq", {
        get: function () {
            return this.bp;
        },
        set: function (a) {
            var b = this.bq;
            if (a == b) {
                return;
            }
            this.bp = a;
            this.a8("ShowCaption", b, this.bp);
        },
        enumerable: true,
        configurable: true
    });
    GridColumnOptionsSimpleSectionBase.prototype.ba = function (a, b, c) {
        _super.prototype.ba.call(this, a, b, c);
        switch (a) {
            case "ShowCaption":
            case "Caption":
                this.e.m();
                break;
        }
    };
    GridColumnOptionsSimpleSectionBase.$t = markType(GridColumnOptionsSimpleSectionBase, 'GridColumnOptionsSimpleSectionBase', GridColumnOptionsSectionBase.$);
    return GridColumnOptionsSimpleSectionBase;
}(GridColumnOptionsSectionBase));
export { GridColumnOptionsSimpleSectionBase };
//# sourceMappingURL=GridColumnOptionsSimpleSectionBase.js.map
